(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('EmployeeAdvertisingSourceReportController', EmployeeAdvertisingSourceReportController);

    EmployeeAdvertisingSourceReportController.$inject = ['$scope', '$state', '$translate', 'EmployeeAdvertisingSourceReport', 'Division', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess', '$filter'];

    function EmployeeAdvertisingSourceReportController ($scope, $state, $translate, EmployeeAdvertisingSourceReport, Division, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess, $filter) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerLargePage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.division = {id:pagingParams.divisionId};
        var allDivisionsTranslate = $translate.instant('telestatApp.reportsCommon.allDivisions');
        vm.divisions = [{id:null,actual:1,title: allDivisionsTranslate}];
        Division.getforselect({},function(data){
            vm.divisions = [{id:null,actual:1,title: allDivisionsTranslate}].concat(makeFlatDivisionList(data, 0));
        });

        vm.exportLink = '';
        vm.UIFormAccess = UIFormAccess;

        vm.dateFilterData = {
                search: search,
                pagingParams: pagingParams,
                initCallBack: loadAll
        };

        vm.reportClean = [];
        vm.report = [];
        vm.mainIdColumn = 'nameId';
        // Centered columns
        vm.mainColumn = {'employeeName':1, 'divisionName':1, 'advertisingSourceName':1};
        vm.totalData = {
                uniqueLeadCount: 1,
                targetedCount: 1,
                missedCount: 1,
                productCount: 1
        };

        function makeLink() {
            var sortResult = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            vm.exportLink = "sort=" + sortResult
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&startDate=' + $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0))
                    + (vm.dateFilterData.dateFilterType == 'all' ? '' : '&endDate=' + $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0))
                    + (vm.division == null || vm.division.id == null ? '' : '&divisionId=' + vm.division.id);
        }
        makeLink();

        function loadAll() {
            makeLink();
            EmployeeAdvertisingSourceReport.query({
                query: pagingParams.search,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                // search with time limits
                startDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0),
                endDate: vm.dateFilterData.dateFilterType == 'all' ? null : $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0),
                divisionId: vm.division == null ? null : vm.division.id
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'employeeName') {
                    result.push('employeeName');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.report = data;
                vm.minData = {};
                vm.maxData = {};
                vm.enableGroupping = (vm.predicate == "employeeName" || vm.predicate == "divisionName");
                getMinMax(vm.minData, vm.maxData, data);
                for (var i = 0 ; i < vm.report.length ; i++ ) {
                    if (vm.report[i][vm.mainIdColumn] == -1) {
                        vm.totalData = vm.report[i];
                        break;
                    }
                }
            }
            function onError(error) {
                var headers = Object.keys(error.headers()).filter(function (header) {
                    return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var alertKey = error.headers(headers[0]);
                if (angular.isString(alertKey)) {
                    AlertService.warning(alertKey, { param : error.headers(headers[1])});
                }
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            vm.dateFilterData.updateDateFilterType();
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                // search with time limits
                searchType: vm.dateFilterData.dateFilterType,
                startDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.startDate, "yyyy-MM-dd", 0) : null,
                endDate: vm.dateFilterData.dateFilterType == 'day' || vm.dateFilterData.dateFilterType == 'range' ? $filter('date')(vm.dateFilterData.endDate, "yyyy-MM-dd", 0) : null,
                divisionId: vm.division == null ? null : vm.division.id
            });
        }

        function search(searchQuery) {
            if (!searchQuery && vm.dateFilterData.dateFilterType == 'all') {
                return vm.clear();
            } else if(!searchQuery) {
                vm.currentSearch = null;
            } else {
                vm.predicate = 'employeeName';
                vm.reverse = false;
                vm.currentSearch = searchQuery;
            }
            vm.links = null;
            vm.page = 1;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'employeeName';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.dateFilterData.setFilterType('all');
            vm.transition();
        }

        vm.columnsRowSpan = [
            'advertisingSourceName',
            'callsCount',
            'uniqueLeadCount',
            'targetedCount',
            'missedCount',
            'uselessCount',
            'productCount'
        ];
        // Main columns list
        vm.columns = ['employeeName'];
        if (vm.division.id == null) {
            vm.columns = vm.columns.concat(['divisionName']);
        }
        vm.columns = vm.columns.concat(vm.columnsRowSpan);
        // Paired columns
        vm.addcolumns = [];
        // Highlighting columns by min/max
        vm.columnsMinMax = [
            'callsCount', 'uniqueLeadCount',
            'targetedCount', 'missedCount',
            'uselessCount', 'productCount'
        ];
        // Inverse min/max on next columns.
        vm.inverseColumns = {'missedCount':1, 'uselessCount':1};

        function getMinMax(min, max, rows) {
            var val = 0;
            var rowspanRow = null;
            var rowspanRowI = -1;
            vm.reportClean = [];
            for (var i = 0 ; i < rows.length ; i++ ) {
                var row = rows[i];
                if (vm.enableGroupping) {
                    if (rowspanRow != null && rowspanRowI != i && rowspanRow['employeeName'] == row['employeeName'] && rowspanRow['divisionName'] == row['divisionName']) {
                        rowspanRow['rowspan'] ++;
                        row['rowspan'] = 'X';
                    } else {
                        rowspanRow = row;
                        rowspanRowI = i;
                        rowspanRow['rowspan'] = 1;
                    }
                } else {
                    row['rowspan'] = 1;
                }
                if (row[vm.mainIdColumn] == -1) continue;
                vm.reportClean.push(row);
                if (val == 0) {
                    val = 1;
                    vm.columnsMinMax.forEach(function (name) {
                        min[name] = row[name];
                        max[name] = row[name];
                    });
                    continue;
                }
                vm.columnsMinMax.forEach(function (name) {
                    if (row[name] !== null) {
                        if (max[name] === null) max[name] = row[name];
                        if (min[name] === null) min[name] = row[name];
                        if (vm.inverseColumns[name] === 1) {
                            if (max[name] > row[name]) max[name] = row[name];
                            if (min[name] < row[name]) min[name] = row[name];
                        } else {
                            if (max[name] < row[name]) max[name] = row[name];
                            if (min[name] > row[name]) min[name] = row[name];
                        }
                    }
                });
            }
        }
        function makeFlatDivisionList(data, level) {
			var divFlatListArr = [];
			for (var i = 0; i < data.length; i++) {
				divFlatListArr.push({
					id : data[i].id,
					actual : true,
					title : ' - '.repeat(level) + data[i].title
				});

				if (data[i].divisions !== undefined
						&& data[i].divisions.length > 0) {
					var t = makeFlatDivisionList(data[i].divisions, level + 1);
					divFlatListArr = divFlatListArr.concat(t);
				}
			}
			return divFlatListArr;
		}
    }
})();
